import { Layout, Text, useTheme } from '@ui-kitten/components';
import { StyleSheet, TouchableOpacity, View, ViewProps } from 'react-native';

import { ProfileIcons } from '../profileMe/ProfileIcons';
import React from 'react';
import { UIHelper as uh } from '../../core';

//props
interface IHealthRecordHeaderProps extends ViewProps {
  healthRecordType: string;
  numberOfRecords: number;
  activeRecords: number;
  isActive: boolean;
  latestRecordDate: string;
  onPress: () => void;
}

const HealthRecordHeader = (props: IHealthRecordHeaderProps) => {
  const th = useTheme();
  // styles
  const styleContainer = StyleSheet.create({
    inactiveContainer: {
      padding: uh.h2DP(16),
      marginTop: uh.h2DP(8),
      borderRadius: 8
    },
    activeContainer: {
      padding: uh.h2DP(16),
      marginTop: uh.h2DP(8),
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8
    },
    content: {
      justifyContent: 'flex-start',
      marginLeft: uh.w2DP(10)
    },
    healthRecordType: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    records: {
      marginTop: uh.h2DP(6)
    },
    icon: {
      width: 20,
      height: 20
    },
    healthRecordInfo: {
      width: uh.h2DP(256),
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  });

  const RightIcon = () => {
    if (props.isActive == true) {
      return <ProfileIcons.UpIcon style={styleContainer.icon} fill={th['color-basic-600']} />;
    } else {
      return <ProfileIcons.DownIcon style={styleContainer.icon} fill={th['color-basic-600']} />;
    }
  };

  // view
  return (
    <TouchableOpacity onPress={props.onPress} activeOpacity={0.7}>
      <Layout style={props.isActive == true ? styleContainer.activeContainer : styleContainer.inactiveContainer}>
        <View style={styleContainer.content}>
          <View style={styleContainer.healthRecordType}>
            <Text category="s1">{props.healthRecordType}</Text>
            {RightIcon()}
          </View>
          <View style={styleContainer.healthRecordInfo}>
            <Text category="c1" appearance="hint" style={styleContainer.records}>
              {`${props.numberOfRecords} Records${props.activeRecords > 0 ? ` (${props.activeRecords} active)` : ''} (${props.latestRecordDate})`}
            </Text>
          </View>
        </View>
      </Layout>
    </TouchableOpacity>
  );
};

export default HealthRecordHeader;
